import { Icons, Images } from "assets";
import classNames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SliderCard from "./sliderCard";
import styles from "./style.module.scss";
// import required modules
import { Autoplay } from "swiper/modules";
import { useState } from "react";
import { EffectCoverflow } from "swiper/modules";

const slidesData: QuestionaireCardOptions[] = [
  {
    title: "Complete the Questionnaire",
    description:
      "Answer a series of questions tailored to evaluate job roles accurately.",
    Icon: Icons.QuestionaireIcon,
    image: Images.QuestionaireImage,
  },
  {
    title: "Submit Your Responses",
    description: "Submit your completed questionnaire for evaluation.",
    Icon: Icons.SubmitIcon,
    image: Images.SubmitImage,
  },
  {
    title: " Get Your Score",
    description:
      "Our system computes and provides a detailed evaluation score.",
    Icon: Icons.ScoreIcon,
    image: Images.ScoreImage,
  },
  {
    title: "Complete the Questionnaire",
    description:
      "Answer a series of questions tailored to evaluate job roles accurately.",
    Icon: Icons.QuestionaireIcon,
    image: Images.QuestionaireImage,
  },
  {
    title: "Submit Your Responses",
    description: "Submit your completed questionnaire for evaluation.",
    Icon: Icons.SubmitIcon,
    image: Images.SubmitImage,
  },
  {
    title: " Get Your Score",
    description:
      "Our system computes and provides a detailed evaluation score.",
    Icon: Icons.ScoreIcon,
    image: Images.ScoreImage,
  },
];
const QuestionaireSection = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  return (
    <section>
      <div className={classNames(styles.customContainer)}>
        <h1 className={classNames(styles.title, "pt-12")}>
          Our Platform Simplifies <span> Job Evaluations</span> With an
          Easy-to-use <span> Questionnaire</span>
        </h1>
        <div className="flex justify-end">
          <p className={classNames(styles.description, "pt-4 pb-6")}>
            Fill out the questionnaire for any job, and our system will
            calculate and generate a comprehensive evaluation score. Your
            evaluations are securely stored, and you can revisit and edit them
            anytime. Here's how it works:
          </p>
        </div>
      </div>
      <div style={{ maxWidth: "1400px", margin: "auto" }}>
        <Swiper
          effect={"coverflow"}
          slidesPerView={"auto"}
          centeredSlides={true}
          grabCursor={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[EffectCoverflow, Autoplay]}
          loop={true}
          className="mySwiper"
          coverflowEffect={{
            rotate: 0,
            stretch: -5,
            depth: 0,
            modifier: 5,
            slideShadows: false,
          }}
          onRealIndexChange={(element: any) => {
            setActiveIndex(element.realIndex);
          }}
        >
          {slidesData?.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <SliderCard item={item} isActive={activeIndex === index} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default QuestionaireSection;
